var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('product-group-card')],1),_c('b-col',[_c('project-product-card')],1)],1),_c('b-row',[_c('b-col',[_c('project-product-amount-card')],1)],1),_c('b-row',[_c('b-col',[_c('project-lines-notes-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }